import PropTypes from "prop-types";
import "./animations-circle.css";
import { useEffect } from "react";
import { getColorForModule } from "../helpers";

export const PulsatingCircle = ({ status = "" }) => {
  const color = getColorForModule(status);
  return (
    <div className="pulsating-circle absolute w-4 h-4 z-50">
      <div
        className={`absolute block z-50 box-border content-empty box-border rounded-full bg-${color}-200 animate-pulse-ring`}
        style={{
          marginLeft: "-100%",
          marginTop: "-100%",
          width: "300%",
          height: "300%",
        }}
      ></div>
      <div
        className={`absolute z-50 left-0 top-0 w-full h-full rounded-full shadow-md animate-pulse-dot bg-${color}-500`}
      ></div>
    </div>
  );
};

PulsatingCircle.propTypes = {
  status: PropTypes.string,
};
